import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Note from "./note";
import {
  createNote,
  deleteNote,
  modifyNote
} from "../../store/actions/detailsDocument/notes";

import "./style.css";
import { useIntl } from "react-intl";

const MessageNote = props => {
  const { docID, notes, scope, noteStatus, typeAccount } = props;

  const intl = useIntl();

  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);

  const [modifyNoteText, setModifyNoteText] = useState(null);
  const [modifyNoteError, setModifyNoteError] = useState("");
  const [ , setCancelButton] = useState(false);
  const [noteId, setNoteId] = useState("");
  const [newNoteText, setNewNoteText] = useState("");
  const [newNoteError, setNewNoteError] = useState("");
  const [addNewNote, setAddNewNote] = useState(false);
  const [ , setRemoveNoteError] = useState("");
  const dispatch = useDispatch();

  const maxChar = 255;

  /** gestisce la visibilità del testo o input + bottoni della modifica */
  function modifyVisibilityObj(noteID, isModifyMode) {
    const actualIdText = document.getElementById("contentText_" + noteID);
    if (!actualIdText) return;
    actualIdText.style.display = isModifyMode ? "none" : "block";
    const actualIdInput = document.getElementById("inputText_" + noteID);
    actualIdInput.style.display = isModifyMode ? "block" : "none";
    actualIdInput.focus();
    const btns = document.getElementById("btns_" + noteID);
    /** gestisce il caso che i bottoni non ci siano per via dello spinner */
    if (btns) {
      btns.style.display = isModifyMode ? "block" : "none";
    }
  }

  /** Al click sul + mostro la nuova nota e imposto il focus */
  function showAddNote() {
    setAddNewNote(true);
    setModifyNoteError("");
    setNewNoteError("");
    setRemoveNoteError("");
    setCancelButton(false);
  }

  /**
   * "Rimuove" la input per la modifica della nota e ripulisce il campo modifica
   * @param {*} noteID : l'identificativo della nota
   */
  function cleanModify(noteID) {
    setModifyNoteText(null);
    setModifyNoteError("");
    setCancelButton(true);
    modifyVisibilityObj(noteID, false);
    // resetNote();
  }

  /**
   * ripulisce il campo input nuova nota
   */
  function cleanAddInput() {
    setNewNoteText(null);
    setAddNewNote(false);
    setModifyNoteError("");
    setNewNoteError("");
    setRemoveNoteError("");
    setCancelButton(true);
  }

  function modifyNoteConfirm(noteID) {
    setNoteId(noteID);
    if (modifyNoteText && modifyNoteText.trim().length !== 0) {
      if (modifyNoteText.trim().length <= maxChar) {
        dispatch(modifyNote(
          auth,
          main.accountantSelected,
          main.accountantIdSelected,
          main.companySelected,
          main.clientIdSelected,
          docID,
          noteID,
          modifyNoteText,
          typeAccount,
          scope
        ))
          .then(() => cleanModify(noteID))
          .catch(() => cleanModify(noteID));
      }
    }
  }

  /** nasconde il testo della nota e al suo posto fa aparire una input text e bottoni per effettuare la modifica */
  function modifyNoteState(noteID, textNote) {
    /*
     * cerco l'elemento da modificare e trasformo il content in una input text per la modifica
     * !!! vado sicura nell'indice 0 della noteContent perchè se ne ho più di uno c'è un problema e non è qui
     */
    setModifyNoteText(textNote);
    setNoteId(noteID);
    modifyVisibilityObj(noteID, true);
  }

  function createNewNote() {
    if (newNoteText && newNoteText.trim().length !== 0) {
      if (newNoteText.trim().length <= maxChar) {
        dispatch(createNote(docID,
          newNoteText));
        setAddNewNote(false);
        setNewNoteText("");
      }
    } else {
      setNewNoteError("Inserire il testo del messaggio");
    }
  }

  /** richiama la action deleteNote per la chiamata api alla delete */
  function startDeleteNote(noteID) {
    setNoteId(noteID);
    dispatch(deleteNote(
      auth,
      main.accountantSelected,
      main.accountantIdSelected,
      main.companySelected,
      main.clientIdSelected,
      docID,
      noteID
    ));
  }

  return (
    <div style={{ marginLeft: "20px" }}>
      <Tooltip placement="top" title={intl.formatMessage({id: "documents.addCommentTooltip", defaultMessage: "Aggiungi un commento"})}
        color={"rgb(0, 80, 117)"}
      >
        <FontAwesomeIcon
          icon={["far", "comment-alt-plus"]}
          onClick={() => showAddNote()}
          style={{ fontSize: "28px", color: "#0090d1", marginBottom: "24px" }}
        />
      </Tooltip>
      {notes
        ? notes.map((item, index) => {
          return (
            <Note
              key={`note_${index}`}
              note={item}
              scope={scope}
              docId={docID}
              index={item.id}
              modifyNoteError={modifyNoteError}
              modifyNoteText={modifyNoteText}
              noteId={noteId}
              noteStatus={noteStatus}
              startDeleteNote={startDeleteNote}
              cleanModify={cleanModify}
              modifyNoteState={modifyNoteState}
              modifyNoteConfirm={modifyNoteConfirm}
              setModifyNoteText={setModifyNoteText}
            />
          );
        })
        : null}
      {addNewNote && (
        <Note
          docId={docID}
          index={0}
          noteStatus={noteStatus}
          cleanModify={cleanModify}
          newNoteError={newNoteError}
          newNoteText={newNoteText}
          modifyNoteConfirm={modifyNoteConfirm}
          cleanAddInput={cleanAddInput}
          typeAccount={typeAccount}
          setNewNoteText={setNewNoteText}
          createNewNote={createNewNote}
          addNewNote={addNewNote}
        />
      )}
    </div>
  );
};

export default MessageNote;
